import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import Procurement from "~/views/procurement"

const getInitialProps: GetInitialPropsType = async ({ req, query }) => {
  const apiContext = await getApiContext(
    [{ url: "/procurement/element", code: query.slug as string }],
    req ? req.headers.host : location.host,
  )

  const { name } = apiContext["/procurement/element"].response
  const crumbs = generateCrumbs(req?.url, name)
  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
Procurement.getInitialProps = getInitialProps

export default Procurement
